import { AbstractCommand } from 'src/models/command';

class MailDeleteByAggregateIdCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Desktop_Actions_DeleteTheSelectedAggregateIds';

	public constructor(aggregateId: string, processId: string) {
		super();
		this.processId = processId;
		this.parameters = {
			aggregateIds: [aggregateId],
		};
	}
}

export { MailDeleteByAggregateIdCommand };
